import { Button, Chip, Tooltip, Typography } from "@mui/material";
import { AGENT_IMAGES_URL } from "../../constants/url";
import { Link } from "react-router-dom";
import { EDIT_AGENT_ROUTE } from "../../constants/routes";

export const AGENT_STATUSES = {
  0: "In Active",
  1: "Active",
};

export const AGENT_COLUMNS = [
  {
    accessorKey: "agentid",
    header: "ID",
    size: 20,
    Cell: ({ row }) => (
      <Link
        to={`${EDIT_AGENT_ROUTE}${row.original.agentid}`}
        style={{  cursor: "pointer" }}
      >
        {row.original.agentid}
      </Link>
    ),
  },
  {
    accessorKey: "agentregno",
    header: "Reg No",
    size: 20,
    Cell: ({ row, cell }) => (
      <Link
        to={`${EDIT_AGENT_ROUTE}${row.original.agentid}`}
        style={{  cursor: "pointer" }}
      >
        {cell.getValue()}
      </Link>
    ),
  },

{
    accessorKey: "firstname", // keep this for filtering
    header: "Full Name",
    size: 30,
    Cell: ({ row }) => {
      const first = row.original.firstName || "";
      const last = row.original.lastname || "";
      const fullName = `${first} ${last}`.trim();

      return (
        <div
          style={{
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 2, // ✅ limit to 2 lines max
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "normal",
            wordBreak: "break-word",
            lineHeight: 1.3,
          }}
        >
           <Link
        to={`${EDIT_AGENT_ROUTE}${row.original.agentid}`}
        style={{  cursor: "pointer" }}
      >
          {fullName || "—"}
          </Link>
        </div>
      );
    },
    filterFn: "includesString", // ensures filtering still uses firstname
  },

  { accessorKey: "agentFatherName", header: " Father's/Husband's Name  ", size: 20 },
  { accessorKey: "cnic", header: "ID No", size: 20 },
  { accessorKey: "brokerLicense", header: "Broker License No", size: 20 },
  { accessorKey: "roleName", header: "Role", size: 20 },
  { accessorKey: "agentExperience", header: "Experience", size: 20 },
  { accessorKey: "agentemail", header: "Email", size: 20 },
  {
    accessorKey: "agentphone",
    header: "Phone",
    size: 20,
    Cell: ({ row }) => (
      <a
        href={`tel:${row.original.agentphone}`}
        style={{ textDecoration: "none", color: "inherit" }}
      >
        {row.original.agentphone}
      </a>
    ),
  },
  {
    accessorKey: "agentjoiningdate",
    header: "Joining Date",
    size: 20,
    Cell: ({ row }) => (
      <div>{new Date(row.original.agentjoiningdate).toLocaleDateString()}</div>
    ),
  },
  {
    accessorKey: "agentcareerstarting",
    header: "Career Start",
    size: 20,
    Cell: ({ row }) => (
      <div>{new Date(row.original.agentcareerstarting).toLocaleDateString()}</div>
    ),
  },
  {
    header: "Image",
    accessorKey: "agentimage",
    Cell: ({ row }) => (
      <img
        src={AGENT_IMAGES_URL + row.original.agentimage}
        alt={"Staff"}
        style={{ width: "50px", height: "50px" }}
      />
    ),
    size: 30,
  },
  {
    header: "Description",
    accessorKey: "agentdescription",
    Cell: ({ row }) => (
      <Tooltip title={row.original.agentdescription} placement="top">
        <div
          style={{
            width: "150px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {row.original.agentdescription}
        </div>
      </Tooltip>
    ),
    size: 30,
  },
  {
    header: "Status",
    accessorKey: "status",
    Cell: ({ row }) => (
      <Chip
        label={AGENT_STATUSES[row.original.status]}
        variant="filled"
        color={row.original.status === 1 ? "success" : "error"}
        size="small"
      />
    ),
    size: 30,
  },
];


